module.exports = __webpack_public_path__ + "static/media/curology-bottles-on-pink-water.7e7eaafd.jpg";